export const isMobile = () => {
	return (
		Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < 768
	);
};
